<template>
  <div>
    <v-card class="mt-3">
      <v-card-text class="">
        <v-row>
          <v-col cols="12" md="4" class="pb-0">
            <v-list two-line class="py-0">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-progress-circular
                      indeterminate
                      v-if="loadingSmac"
                      size="20"
                    ></v-progress-circular>
                    <div v-else>
                      {{ smac.sessionsActivesNumber }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Sessions actives
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col cols="12" md="4" class="pb-0">
            <v-list two-line class="py-0">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-progress-circular
                      indeterminate
                      v-if="loadingSmac"
                      size="20"
                    ></v-progress-circular>
                    <div v-else>
                      {{ smac.macAddressesNumber }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle> MAC adresses </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col cols="12" md="4" class="pb-1">
            <v-list two-line class="py-0">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-progress-circular
                      indeterminate
                      v-if="loadingSmac"
                      size="20"
                    ></v-progress-circular>
                    <div v-else>
                      {{ smac.attributesNumber }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Attributs Radius
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { defineComponent, toRef, onMounted } from "@vue/composition-api";
import { useClientPortal } from "@/composables/client-portal";

export default defineComponent({
  props: {
    clientPortalId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    /* Import des API */
    const { data, fetchSmac } = useClientPortal();

    /* Cycle de vie */
    onMounted(async () => {
      await fetchSmac(props.clientPortalId);
    });

    return {
      smac: toRef(data, "smac"),
      loadingSmac: toRef(data, "loadingSmac"),
    };
  },
});
</script>
